<template>
  <el-drawer
    title="设置"
    :visible.sync="drawerVisible"
    direction="btt"
    size="60%"
    :wrapperClosable="true"
    :close-on-press-escape="false"
    @close="closeDrawer"
  >
    <div class="setting-container">
      <div class="setting-item">
        <div class="setting-label">调整字体大小</div>
        <el-slider
          v-model="fontSizeVal"
          :step="20"
          :min="30"
          :max="150"
          :show-tooltip="false"
          @input="handleFontSizeChange"
          show-stops
        >
        </el-slider>
        <div class="demonstration">
          <span class="little-font">小</span><span class="big-font">大</span>
        </div>
      </div>
      <div class="setting-item">
        <div class="setting-label">设置背景颜色</div>
        <ul class="set-bg-color">
          <li
            v-for="i in 7"
            :key="i"
            :class="['bg' + i, activeBg == i ? 'active' : '']"
            @click="changeBg($event, i)"
          ></li>
          <!-- <li class="bg1" @click="changeBg"></li>
          <li class="bg2 active" @click="changeBg"></li>
          <li class="bg3" @click="changeBg"></li>
          <li class="bg4" @click="changeBg"></li>
          <li class="bg5" @click="changeBg"></li>
          <li class="bg6" @click="changeBg"></li> -->
        </ul>
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
    name: "setting",
    props: {
      //drawer 是否展示
      visible: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        drawerVisible: false,
        fontSizeVal: 50,
        activeBg: 3
      }
    },
    watch: {
      visible(newVal) {
        this.drawerVisible = newVal
      }
    },
    methods: {
      // 设置字体大小
      handleFontSizeChange(value) {
        this.$emit('fontSizeChange', value)
      },
      changeBg(event, index) {
        this.activeBg = index
        let element = event.target
        let style = element.currentStyle || window.getComputedStyle(element);
        let backgroundColor = style.backgroundColor;
        this.$emit('backgroundColorChange', backgroundColor)
      },
      // 关闭弹窗
      closeDrawer() {
        this.$emit('closeDrawer', 'setting')
      },
    }
  }
</script>

<style lang="scss" scoped>
.setting-container{
  background: #F7F7F7;
  padding: 0 24rem;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  padding-bottom: 128rem;
  
  .setting-item{
    background: #fff;
    border-radius: 10rem;
    padding: 0 50rem;
    margin-top: 25rem;
    overflow: hidden;

    &:nth-child(2){
      padding: 0 20rem;
    }

    .setting-label{
      font-size: 28rem;
      margin-top: 60rem;
      text-align: center;
    }
    
    .demonstration {
      width: 100%;
      margin: 30rem 0;
      display: flex;
      justify-content: space-between;
      .little-font {
        font-size: 24rem;
        font-weight: bold;
      }
      .big-font {
        font-size: 36rem;
        font-weight: bold;
      }
    }
    
    .set-bg-color {
      width: 100%;
      margin: 60rem auto;
      display: flex;
      justify-content: space-around;

      li {
        width: 66rem;
        height: 66rem;
        border-radius: 33rem;
        border: 6rem solid #c1c1c1;
        transform: scale(1);
        transition: transform 0.2s;
      }
      li.bg1 {
        background: #fff;
      }
      li.bg2 {
        background: #d5edf4;
      }
      li.bg3 {
        background: #DBECFA;
      }
      li.bg4 {
        background: #ebfbf8;
      }
      li.bg5 {
        background: #fafbeb;
      }
      li.bg6 {
        background: #f8ebe5;
      }
      li.bg7 {
        background: #f4edf6;
      }
      li:hover {
        transform: scale(1.2);
      }
      li.active {
        transform: scale(1.1);
        border: 6rem solid #0FC29A;
      }
    }
  }
}
/deep/.el-slider{
  .el-slider__runway{
    background: #DDDDDD;

    .el-slider__bar{
      background: #0FC29A;
    }

    .el-slider__button{
      border: solid 2rem #0FC29A;
    }
  }
}
/deep/.el-drawer{
  border-radius: 20rem 20rem 0 0;

  .el-drawer__header{
    padding: 0 42rem 0 32rem;
    margin: 0;

    span{
      font-size: 36rem;
      color: #333;
      font-weight: bold;
      line-height: 112rem;
    }

    .el-drawer__close-btn{
      font-size: 36rem;
    }
  }
}
</style>